import React from 'react';
import { Settings, User, CalendarDays } from 'lucide-react';
import { useAuthContext } from '../../context/AuthContext';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const AccountModal = () => {
  const auth = useAuthContext();
  const app = useAppContext();

  const isOpen = app.showAccountModal && auth.isLoggedIn && auth.isSubscribed;

  return (
    <Modal isOpen={isOpen} onClose={() => app.setShowAccountModal(false)}>
      <div className="modal__header">
        <div className="modal__icon-wrapper">
          <Settings size={28} color="white" />
        </div>
        <h2 className="modal__title">My Subscription</h2>
      </div>

      <div className="account-modal__content">
        <div className="account-section">
          <div className="account-detail">
            <span className="account-detail__label">
              <User className="icon-sm" /> Account
            </span>
            <span className="account-detail__value">
              {auth.user?.name || 'Trader'}
            </span>
          </div>
        </div>

        <div className="account-section">
          <div className="account-section__title">Plan Details</div>
          <div className="account-detail">
            <span className="account-detail__label">Plan</span>
            <span className="account-detail__value">AlphaNQ Premium</span>
          </div>
          <div className="account-detail">
            <span className="account-detail__label">Status</span>
            <span className="account-detail__value account-detail__value--active">Active</span>
          </div>
          <div className="account-detail">
            <span className="account-detail__label">Price</span>
            <span className="account-detail__value">
              {app.hasDiscount ? (
                <>
                  <span className="account-detail__old-price">$99/mo</span>
                  $49.50/mo
                </>
              ) : (
                '$99/month'
              )}
            </span>
          </div>
          <div className="account-detail">
            <span className="account-detail__label">
              <CalendarDays className="icon-sm" /> Renews on
            </span>
            <span className="account-detail__value">October 26, 2026</span>
          </div>
          {app.hasDiscount && (
            <div className="account-detail account-detail--highlight">
              <span className="account-detail__label">Discount</span>
              <span className="account-detail__value account-detail__value--primary">
                Applied to next bill
              </span>
            </div>
          )}
        </div>

        <div className="account-section">
          <button
            className="btn btn-secondary btn-full"
            onClick={() => {
              app.setShowAccountModal(false);
              app.setShowBillingModal(true);
            }}
          >
            Manage Billing
          </button>
        </div>
      </div>

      <div className="modal__footer">
        <p className="modal__footer-text">
          Need help? <span className="modal__footer-link">Contact Support</span>
        </p>
      </div>
    </Modal>
  );
};

export default AccountModal;
